/**
 * Sets URL search parameters as data attributes on the mount element.
 * Non-blank URL parameters override existing HTML and environment defaults.
 * @param mountElement - The element to receive the data attributes.
 * @param urlParams - The URL search parameters to read values from.
 * @param keys - The parameter keys to transfer as data attributes.
 */
export function setDataAttributesFromUrl(mountElement: HTMLElement, urlParams: URLSearchParams, keys: readonly string[]) {
  keys.forEach((key) => {
    const value = urlParams.get(key)
    if (value === null || value.trim() === '') return

    const attributeName = `data-${key.replace(/_/g, '-')}`
    if (mountElement.hasAttribute(attributeName)) {
      console.warn(`[Leasing Calculator]: ${attributeName} is overridden by a URL parameter`)
    }
    mountElement.setAttribute(attributeName, value)
  })
}
